import { Icon, IconButton } from '@atom/mui';
import { LensIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';

import classes from './workTemplateWalkThrough.module.css';

const styles = {
  icon: {
    fontSize: '12px',
  },
  iconButton: {
    margin: '0 0.25rem',
  },
};

interface Props {
  page: number;
  pages: {
    title: string;
    content: string;
    imageUrl: string;
  }[];
  setPage: (page: number) => void;
}

const WalkThroughPage = ({ page, pages, setPage }: Props) => {
  const currentPage = pages[page];

  return (
    <div>
      <div
        className={classes.pageTitle}
      >{`${page + 1}. ${currentPage?.title}`}</div>
      <div className={classes.pageContent}>{currentPage?.content}</div>
      <div className={classes.pageImage}>
        <img src={currentPage?.imageUrl} />
      </div>
      <div className={classes.pageNavigation}>
        {pages.map((_, index) => {
          const buttonColor =
            index > page ? colors.neutral.typhoon : colors.neutral.gray;

          return (
            <IconButton
              style={styles.iconButton}
              onClick={() => setPage(index)}
              size="small"
            >
              <Icon style={styles.icon} color={buttonColor} icon={LensIcon} />
            </IconButton>
          );
        })}
      </div>
    </div>
  );
};

export default WalkThroughPage;
